<template>
  <div class="container_presentation" v-if="course.name">
    <div class="spacer"></div>
    <div class="spacer"></div>
    <b-container>
      <b-row>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/logo_rectangle_sm.png" alt="Logo challenge maritima" />
        </b-col>
        <b-col md="6">
          <h2 style="font-weight: bold">
            {{ course.name }}
            - {{ course.distance }}
          </h2>

          <h4>{{ course.date }} - Départ 9h30</h4>
        </b-col>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/Logo_TotalEnergies.png" alt="Logo Total energies" />
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="3" md="6">
          <div class="spacer"></div>
          <!-- <img src="@/assets/img/courses/parcours_castillon.jpg" alt="" />
          <div class="spacer"></div> -->
          <p>
            <u>Carro Carry : la course du bord de mer</u><br />

            D’une longueur de 14km le parcours de la course Carro-Carry permet de relier Carro à Carry-le-Rouet en longeant le bord de mer. Ce sera cette année la 29ème édition.<br />

            Avec entre 1400 et 2000 inscrits lors des dernières éditions, la course Carro Carry est une des courses les plus fréquentées des Bouches du Rhône.<br />

            L’organisation de la course est assurée par l’association Carry5 qui s’appuie sur plus de 200 bénévoles.<br />

            Nicolas Navarro : premier Français au Marathon des jeux olympiques de Tokyo en 2020 et vainqueur pour la sixième fois de Carro-Carry en 2022 et Floriane Hot : Championne du monde du 100 km en 2022 nous ont dit en 2022 qu’ils comptaient
            bien participer à l’édition 2023.
          </p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <div class="spacer"></div>
      <b-row>
        <b-col md="2"></b-col>
        <b-col md="4">
          <img src="@/assets/img/courses/4Dsc_0206.jpg" alt="" />
        </b-col>
            <b-col md="4">
          <img :src="'https://sportips.fr/challenge-maritima/img/flyer/' + course.url_flyer" alt="" />
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-col>
          <p><b>Contact : Michel Sauermann tel 06 20 15 47 29 mail : michel.sauermann@gmail.com</b></p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <b-row>
        <b-col>
          <b-button class="infos_btn" download href="https://sportips.fr/challenge-maritima/uploads/carro_carry_2022-15466383-1678897820-560.gpx" target="_blank">GPX de l'épreuve</b-button>
          <!-- <b-button class="infos_btn" href="https://rondedespontsbleus.msathle.com/" target="_blank">Infos course</b-button> -->
          <b-button class="infos_btn" download href="https://sportips.fr/challenge-maritima/uploads/reglement_carro_carry_23.docx" target="_blank">Réglement</b-button>

          <b-button class="infos_btn" href="https://www.kms.fr/v5/public/" target="_blank">Inscriptions</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["course"],
  created() {},
};
</script>

<style lang="scss" scoped>
</style>